/* TOMAPREÇO · mini-carrinho · ÁREA B (versão base entregue na fase 3; o pane B evolui)
 * Ouve 'tp:cart:updated' (disparado por TP.cart.add) e desenha a gaveta #tp-mcart.
 */
(function () {
  'use strict';
  function ready(fn) { if (window.TP) fn(); else document.addEventListener('DOMContentLoaded', fn); }
  ready(function () {
    var TP = window.TP; if (!TP) return;
    var d = document.getElementById('tp-mcart'); if (!d) return;
    var body = d.querySelector('[data-tp-mcart-body]'), foot = d.querySelector('[data-tp-mcart-foot]'),
      sub = d.querySelector('[data-tp-mcart-subtotal]'), ok = d.querySelector('[data-tp-mcart-ok]');
    function img(u) { if (!u) return ''; return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=144'; }
    function render(cart) {
      if (!cart.item_count) {
        body.innerHTML = '<div class="tp-empty"><p><strong>Seu carrinho está vazio</strong></p><a class="tp-btn tp-btn--blue" href="/">Continuar comprando</a></div>';
        foot.hidden = true; return;
      }
      body.innerHTML = cart.items.map(function (it) {
        return '<div class="tp-mcart__item"><a href="' + TP.esc(it.url) + '">' + (it.image ? '<img src="' + TP.esc(img(it.image)) + '" alt="" width="72" height="72" loading="lazy">' : '') + '</a><div>'
          + '<a class="tp-mcart__name" href="' + TP.esc(it.url) + '">' + TP.esc(it.product_title) + '</a>'
          + (it.variant_title ? '<div class="tp-mcart__var">' + TP.esc(it.variant_title) + '</div>' : '')
          + '<div class="tp-mcart__row"><span>Qtd. ' + it.quantity + '</span><span class="tp-mcart__price">' + TP.money(it.final_line_price) + '</span></div></div></div>';
      }).join('');
      sub.textContent = TP.money(cart.total_price);
      foot.hidden = false;
    }
    TP.miniCart = { render: render };
    document.addEventListener('tp:cart:updated', function (e) {
      render(e.detail.cart);
      if (ok) ok.hidden = !e.detail.added;
      TP.drawer.open('tp-mcart');
    });
    d.addEventListener('tp:drawer:open', function () { if (!body.innerHTML) TP.cart.get().then(render); });
  });
})();
